export interface Tool {
  id: number;
  name: string;
  description: string;
  price: string;
  rating: number;
  categories: {
    function: string[];
    pricing: string[];
    industry: string[];
  };
  createdAt: string;
  popularity: number;
}

export const tools: Tool[] = [
  {
    id: 1,
    name: "ChatGPT",
    description: "Advanced AI chatbot with natural language processing",
    price: "Freemium",
    rating: 4.8,
    categories: {
      function: ["Chatbot", "Text Generation"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Education", "Customer Service"]
    },
    createdAt: "2022-11-30",
    popularity: 95
  },
  {
    id: 2,
    name: "Midjourney",
    description: "AI-powered image generation from text prompts",
    price: "Paid",
    rating: 4.5,
    categories: {
      function: ["Image Generation", "Creative"],
      pricing: ["Paid"],
      industry: ["Design", "Marketing"]
    },
    createdAt: "2022-07-12",
    popularity: 88
  },
  {
    id: 3,
    name: "Notion AI",
    description: "AI-powered workspace with smart organization",
    price: "Freemium",
    rating: 4.3,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2023-02-15",
    popularity: 82
  },
  {
    id: 4,
    name: "Claude",
    description: "AI assistant focused on helpful, harmless, and honest interactions",
    price: "Freemium",
    rating: 4.6,
    categories: {
      function: ["Chatbot", "Text Generation"],
      pricing: ["Freemium"],
      industry: ["Education", "Customer Service"]
    },
    createdAt: "2023-03-15",
    popularity: 85
  },
  {
    id: 5,
    name: "Gemini",
    description: "Google's advanced conversational AI service (formerly Bard)",
    price: "Free",
    rating: 4.4,
    categories: {
      function: ["Chatbot", "Text Generation"],
      pricing: ["Free"],
      industry: ["Education", "Search"]
    },
    createdAt: "2023-05-10",
    popularity: 80
  },
  {
    id: 6,
    name: "DALL-E",
    description: "AI system that can create realistic images from text descriptions",
    price: "Freemium",
    rating: 4.5,
    categories: {
      function: ["Image Generation", "Creative"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Design", "Marketing"]
    },
    createdAt: "2021-01-05",
    popularity: 87
  },
  {
    id: 7,
    name: "Stable Diffusion",
    description: "Open source text-to-image generation model",
    price: "Free",
    rating: 4.3,
    categories: {
      function: ["Image Generation", "Creative"],
      pricing: ["Free"],
      industry: ["Design", "Art"]
    },
    createdAt: "2022-08-22",
    popularity: 84
  },
  {
    id: 8,
    name: "Grammarly",
    description: "AI-powered writing assistant for grammar and style",
    price: "Freemium",
    rating: 4.7,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2009-01-01",
    popularity: 90
  },
  {
    id: 9,
    name: "Copy.ai",
    description: "AI-powered copywriting assistant for marketing content",
    price: "Freemium",
    rating: 4.2,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Marketing", "Business"]
    },
    createdAt: "2020-10-15",
    popularity: 78
  },
  {
    id: 10,
    name: "Jasper",
    description: "AI content creator for businesses and marketers",
    price: "Subscription",
    rating: 4.4,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Subscription"],
      industry: ["Marketing", "Business"]
    },
    createdAt: "2021-02-01",
    popularity: 82
  },
  {
    id: 11,
    name: "Perplexity",
    description: "AI search engine with conversational interface",
    price: "Free",
    rating: 4.3,
    categories: {
      function: ["Chatbot", "Search"],
      pricing: ["Free"],
      industry: ["Education", "Research"]
    },
    createdAt: "2022-08-01",
    popularity: 79
  },
  {
    id: 12,
    name: "Runway ML",
    description: "Creative toolkit powered by machine learning",
    price: "Freemium",
    rating: 4.1,
    categories: {
      function: ["Image Generation", "Video Editing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Design", "Art"]
    },
    createdAt: "2018-01-01",
    popularity: 75
  },
  {
    id: 13,
    name: "Fireflies",
    description: "AI notetaker for meetings and conversations",
    price: "Freemium",
    rating: 4.4,
    categories: {
      function: ["Productivity", "Transcription"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2019-05-15",
    popularity: 81
  },
  {
    id: 14,
    name: "Synthesia",
    description: "AI video generation platform with digital avatars",
    price: "Subscription",
    rating: 4.2,
    categories: {
      function: ["Video Generation", "Creative"],
      pricing: ["Subscription"],
      industry: ["Marketing", "Education"]
    },
    createdAt: "2017-01-01",
    popularity: 77
  },
  {
    id: 15,
    name: "Otter.ai",
    description: "AI-powered voice meeting assistant",
    price: "Freemium",
    rating: 4.5,
    categories: {
      function: ["Productivity", "Transcription"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2016-01-01",
    popularity: 83
  },
  {
    id: 16,
    name: "Descript",
    description: "AI-powered audio and video editing tool",
    price: "Freemium",
    rating: 4.3,
    categories: {
      function: ["Video Editing", "Audio Editing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Media", "Marketing"]
    },
    createdAt: "2017-01-01",
    popularity: 78
  },
  {
    id: 17,
    name: "Murf",
    description: "AI voice generator for text-to-speech",
    price: "Freemium",
    rating: 4.2,
    categories: {
      function: ["Audio Generation", "Creative"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Media", "Education"]
    },
    createdAt: "2020-06-01",
    popularity: 76
  },
  {
    id: 18,
    name: "Beautiful.ai",
    description: "AI-powered presentation design tool",
    price: "Subscription",
    rating: 4.1,
    categories: {
      function: ["Productivity", "Design"],
      pricing: ["Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2015-01-01",
    popularity: 74
  },
  {
    id: 19,
    name: "Tome",
    description: "AI-powered storytelling and presentation tool",
    price: "Freemium",
    rating: 4.0,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2020-01-01",
    popularity: 73
  },
  {
    id: 20,
    name: "Quillbot",
    description: "AI-powered paraphrasing and writing tool",
    price: "Freemium",
    rating: 4.3,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Education", "Business"]
    },
    createdAt: "2017-01-01",
    popularity: 79
  },
  {
    id: 21,
    name: "Krisp",
    description: "AI-powered noise cancellation for calls",
    price: "Freemium",
    rating: 4.6,
    categories: {
      function: ["Audio Processing", "Productivity"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2017-01-01",
    popularity: 85
  },
  {
    id: 22,
    name: "DeepL",
    description: "AI-powered translation tool with high accuracy",
    price: "Freemium",
    rating: 4.7,
    categories: {
      function: ["Translation", "Productivity"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2017-08-01",
    popularity: 86
  },
  {
    id: 23,
    name: "ElevenLabs",
    description: "AI voice generation and text-to-speech platform",
    price: "Freemium",
    rating: 4.4,
    categories: {
      function: ["Audio Generation", "Creative"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Media", "Education"]
    },
    createdAt: "2022-01-01",
    popularity: 80
  },
  {
    id: 24,
    name: "Pictory",
    description: "AI video creation from text content",
    price: "Subscription",
    rating: 4.1,
    categories: {
      function: ["Video Generation", "Creative"],
      pricing: ["Subscription"],
      industry: ["Marketing", "Media"]
    },
    createdAt: "2019-01-01",
    popularity: 75
  },
  {
    id: 25,
    name: "Chatsonic",
    description: "AI chatbot with web search capabilities",
    price: "Freemium",
    rating: 4.3,
    categories: {
      function: ["Chatbot", "Text Generation"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2022-12-01",
    popularity: 79
  },
  {
    id: 26,
    name: "Writesonic",
    description: "AI writing assistant for marketing content",
    price: "Freemium",
    rating: 4.2,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Marketing", "Business"]
    },
    createdAt: "2020-10-01",
    popularity: 77
  },
  {
    id: 27,
    name: "Canva Magic Write",
    description: "AI-powered text generation for designs",
    price: "Freemium",
    rating: 4.1,
    categories: {
      function: ["Productivity", "Design"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Marketing", "Business"]
    },
    createdAt: "2022-10-01",
    popularity: 76
  },
  {
    id: 28,
    name: "Adobe Firefly",
    description: "AI-powered creative tools for image generation",
    price: "Subscription",
    rating: 4.3,
    categories: {
      function: ["Image Generation", "Creative"],
      pricing: ["Subscription"],
      industry: ["Design", "Art"]
    },
    createdAt: "2023-03-01",
    popularity: 80
  },
  {
    id: 29,
    name: "HeyGen",
    description: "AI video generation with digital avatars",
    price: "Subscription",
    rating: 4.0,
    categories: {
      function: ["Video Generation", "Creative"],
      pricing: ["Subscription"],
      industry: ["Marketing", "Education"]
    },
    createdAt: "2020-01-01",
    popularity: 74
  },
  {
    id: 30,
    name: "Poe",
    description: "AI chatbot platform with multiple models",
    price: "Freemium",
    rating: 4.2,
    categories: {
      function: ["Chatbot", "Text Generation"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Education", "Business"]
    },
    createdAt: "2022-12-01",
    popularity: 78
  },
  {
    id: 31,
    name: "Gamma",
    description: "AI-powered presentation and document creation",
    price: "Freemium",
    rating: 4.1,
    categories: {
      function: ["Productivity", "Design"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2021-01-01",
    popularity: 75
  },
  {
    id: 32,
    name: "Rewind",
    description: "AI-powered personal memory assistant",
    price: "Subscription",
    rating: 4.0,
    categories: {
      function: ["Productivity", "Search"],
      pricing: ["Subscription"],
      industry: ["Business", "Personal"]
    },
    createdAt: "2021-01-01",
    popularity: 73
  },
  {
    id: 33,
    name: "Mem",
    description: "AI-powered note-taking and knowledge management",
    price: "Freemium",
    rating: 4.2,
    categories: {
      function: ["Productivity", "Writing"],
      pricing: ["Freemium", "Subscription"],
      industry: ["Business", "Education"]
    },
    createdAt: "2020-01-01",
    popularity: 77
  }
];